import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// components
import { AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { PreviewBox, Image, Title, Button, Description, ContentWrapper } from './StyledElements';

const StyledPreviewBox = styled(PreviewBox)`
  height: 75%;
`;

const StyledImage = styled(Image)`
  width: 50%;
  padding-bottom: 50%;
  display: inline-block;
  vertical-align: middle;
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate2: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <StyledPreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <StyledImage isTemplateSelected={isTemplateSelected} />
      <ContentWrapper>
        <Title />
        <Description />
        <Description />
        <Description />
        <Description />
        <Button isTemplateSelected={isTemplateSelected} />
      </ContentWrapper>
    </StyledPreviewBox>
  );
};

export default PreviewTemplate2;
